module.exports = __webpack_public_path__ + "assets/img/again-btn.964b2f9b.png";